var exports = {
  "kL": "VoiceControlBar.module__container___ZzlTeF",
  "UD": "VoiceControlBar.module__buttonContainer___ZzlTeF",
  "x6": "VoiceControlBar.module__button___ZzlTeF",
  "QV": "VoiceControlBar.module__buttonMuted___ZzlTeF",
  "rp": "VoiceControlBar.module__buttonUnmuted___ZzlTeF",
  "Jt": "VoiceControlBar.module__buttonDeafened___ZzlTeF",
  "Zj": "VoiceControlBar.module__buttonCameraOn___ZzlTeF",
  "PQ": "VoiceControlBar.module__buttonCameraOff___ZzlTeF",
  "bt": "VoiceControlBar.module__buttonScreenShareOn___ZzlTeF",
  "fB": "VoiceControlBar.module__buttonScreenShareOff___ZzlTeF",
  "_p": "VoiceControlBar.module__buttonMoreOptions___ZzlTeF",
  "Zt": "VoiceControlBar.module__buttonDisconnect___ZzlTeF",
  "Q1": "VoiceControlBar.module__buttonSeparator___ZzlTeF",
  "Se": "VoiceControlBar.module__settingsButton___ZzlTeF",
  "on": "VoiceControlBar.module__stopWatchingButton___ZzlTeF",
  "Kk": "VoiceControlBar.module__icon___ZzlTeF",
  "Bx": "VoiceControlBar.module__iconSmall___ZzlTeF",
};

module.exports = exports;
